import React, { useEffect } from 'react';
import {
  Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Typography, useMediaQuery, useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const parseMessage = (raw) => {
  if (typeof raw !== 'string') return raw || {};
  try { return JSON.parse(raw); } catch { return {}; }
};

/**
 * Shows the Finvu consent page. Completion is tracked by the backend (webhooks + status polling
 * in WealthConnect). Finvu's 'AA_FLOW_COMPLETE' message closes the window straight away
 * (onFinished); the user closing it early goes to onClose.
 */
function AaConsentModal({ title, redirectUrl, onClose, onFinished }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const onMessage = (event) => {
      const msg = parseMessage(event.data);
      if (msg.type === 'AA_FLOW_COMPLETE') {
        const status = (msg.payload || msg.data || {}).status;
        console.info('[AA] consent window finished', status);
        onFinished(status);
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [onFinished]);

  const openPopup = () => window.open(redirectUrl, 'aa-consent', 'width=520,height=760');

  return (
    <Dialog open onClose={onClose} fullScreen={fullScreen} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        {title}
        <IconButton aria-label="Close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="body2" color="text.secondary" sx={{ px: 2, py: 1.5 }}>
          Approve the consent with the OTP sent by Finvu. This window closes by itself once you approve.
        </Typography>
        <Box
          component="iframe"
          title={title}
          src={redirectUrl}
          sx={{ border: 0, width: '100%', flex: 1, minHeight: fullScreen ? 0 : 620 }}
        />
        <Box sx={{ p: 1.5, textAlign: 'center' }}>
          <Button size="small" onClick={openPopup}>Page not loading? Open in a new window</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default AaConsentModal;
